/* RESPONSIBLE TEAM: team-data-foundations */
import Model, { attr } from '@ember-data/model';

export default class AppSsoDomain extends Model {
  @attr('string') domain;
  @attr('string') verificationDomainName;
  @attr('string') verificationDomainValue;
  @attr('string') state;
}
